export default "__VITE_ASSET__Bml8Bxk0__"